import React from 'react'
import { Flex } from '../../index'
import { brandColors } from '../../../../../shared/basicPalette'
import { FlexProps } from '@chakra-ui/react'

export const Byline = ({
  children,
  ...props
}: FlexProps & {
  children: React.ReactNode
}) => (
  <Flex
    color={brandColors.grey.mid}
    wrap="wrap"
    fontSize="14px"
    pb="4px"
    align="center"
    {...props}
  >
    {children}
  </Flex>
)

export const BylineSection = ({
  children,
  showDot = true,
  ...props
}: FlexProps & {
  children: React.ReactNode
  showDot?: boolean
}) => (
  <Flex
    align="center"
    whiteSpace="nowrap"
    mr="4px"
    {...props}
    _after={showDot ? { content: '" • "', marginLeft: '4px' } : undefined}
  >
    {children}
  </Flex>
)
